import React from 'react';
import { Spinner, Center, Text, VStack, Box } from '@chakra-ui/react';

interface LoadingSpinnerProps {
  text?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  withText?: boolean;
  fullHeight?: boolean;
  fullPage?: boolean;
  centerInParent?: boolean;
}

/**
 * Componente LoadingSpinner che mostra un indicatore di caricamento circolare animato
 * con opzionale testo di accompagnamento
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  text = 'Caricamento in corso...',
  size = 'md',
  withText = true,
  fullHeight = false,
  fullPage = false,
  centerInParent = true
}) => {
  const content = (
    <VStack spacing={2}>
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size={size}
      />
      {withText && <Text fontSize="sm" color="gray.600">{text}</Text>}
    </VStack>
  );

  if (fullPage) {
    return (
      <Center h="100vh" w="100vw" position="fixed" top={0} left={0} zIndex={9999} bg="rgba(255, 255, 255, 0.8)">
        {content}
      </Center>
    );
  }

  if (centerInParent) {
    return (
      <Center h={fullHeight ? "100vh" : "200px"} w="full">
        {content}
      </Center>
    );
  }

  return (
    <Box py={4}>
      {content}
    </Box>
  );
};

export default LoadingSpinner;